<ng-template #confirmtemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeConfirmRemoveDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="text-start">Are you sure you want to delete this item? This operation can not be undone.</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn at-ct-btn-ib-white-with-dark-bg" [disabled]="deletingProgress" (click)="closeConfirmRemoveDialog()">Cancel</button>
    <button type="button" class="btn btn-danger" [disabled]="deletingProgress" (click)="confirmEntityDeletion()">
      <span *ngIf="deletingProgress"><i class="fas fa-spinner fa-spin"></i> Deleting...</span>
      <span *ngIf="!deletingProgress">Yes, delete</span>
    </button>
  </div>
</ng-template>

<div class="ms-2">
  <button *ngIf="editable" class="btn btn-action" (click)="showEntity()" title="Edit"><i class="fa fa-edit"></i></button>
  <button *ngIf="!editable && readable" class="btn btn-action" (click)="showEntity()" title="View"><i class="fas fa-eye"></i></button>
  <button *ngIf="removable" class="btn btn-action" (click)="confirmRemoveDialog(confirmtemplate)" title="Delete"><i class="fa fa-trash-alt"></i></button>
</div>
